import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Button,
  CircularProgress,
  Stack
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';

import { Url } from './url';
import NewSupplierDialog from './NewSupplierDialog';
import EditSupplierDialog from './EditSupplierDialog';
import { authFetch, authFetchRequest } from './utils/api'; // ✅ Use your API utils
import { alertC, confirmC } from './components/dialogService';


const Suppliers = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedRow, setSelectedRow] = useState(null);
  const [openNewDialog, setOpenNewDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [editRowData, setEditRowData] = useState(null);

  const [paginationModel, setPaginationModel] = useState({
      page: 0,
      pageSize: 10,
  });

  const fetchSuppliers = () => {
    setLoading(true);
    authFetch(`/suppliers/`)
      .then(data => {
        setRows(data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Failed to fetch suppliers:', err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchSuppliers();
  }, []);

  const handleOpenEditDialog = (row) => {
    if (!row) {
      console.warn('No row selected for editing');
      return;
    }

    setEditRowData(row);
    setOpenEditDialog(true);
  };

  const handleDelete = async () => {
    if (!selectedRow) return;
    const confirmed = await confirmC("Are you sure you want to delete this item?");
    if (!confirmed) return;
    try {
      await authFetchRequest(`${Url}/suppliers/${selectedRow.id}`, null, "DELETE");
      fetchSuppliers();
      setSelectedRow(null);
    } catch (err) {
      console.error("Delete failed:", err);
    }
  };

  const columns = [
    { field: 'id', headerName: 'ID', width: 90 },
    { field: 'name', headerName: 'Name', width: 200, editable: true },
    { field: 'city', headerName: 'City', width: 150, editable: true },
    { field: 'phone', headerName: 'Phone', width: 150, editable: true },
    { field: 'email', headerName: 'Email', width: 250, editable: true },
    { field: 'discount', headerName: 'Discount', width: 80, editable: true },
    { field: 'products', headerName: 'Products', width: 80, editable: true },
    { field: 'netTerms', headerName: 'Net Terms', width: 80, editable: true },
    { field: 'fullName', headerName: 'Full Name', width: 150, editable: true },
    { field: 'mobilePhone', headerName: 'Mobile', width: 90, editable: true },
    { field: 'address1', headerName: 'Address1', width: 150, editable: true },
    { field: 'address2', headerName: 'Address2', width: 20, editable: true },
    { field: 'province', headerName: 'Province', width: 80, editable: true },
    { field: 'country', headerName: 'Country', width: 80, editable: true },
    { field: 'postalCode', headerName: 'Zip', width: 80, editable: true }
  ];

  return (
    <Box sx={{ height: 600, width: '100%' }} className="content-container">
      {/*<Typography variant="h6" gutterBottom>Suppliers</Typography>*/}
      <h3>Suppliers</h3>

      <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
        <Button variant="contained" onClick={() => setOpenNewDialog(true)}>
          Add Supplier
        </Button>

        <Button
          variant="contained"
          color="secondary"
          onClick={() => handleOpenEditDialog(selectedRow)}
          disabled={!selectedRow}
        >
          Edit Supplier
        </Button>

        <Button
          variant="outlined"
          color="error"
          onClick={handleDelete}
          disabled={!selectedRow}
        >
          Delete Supplier
        </Button>
      </Stack>

      {loading ? (
        <CircularProgress />
      ) : (
        <DataGrid
          autoHeight
          rowHeight={30}

          pageSize={10}
          pagination
          paginationModel={paginationModel}
          onPaginationModelChange={(model) => setPaginationModel(model)}
          rowsPerPageOptions={[10, 20, 50]} // 👈  dropdown options
          pageSizeOptions={[10, 20, 50]}    // 👈 fallback for older versions

          rows={rows}
          columns={columns}
          onRowClick={(params) => setSelectedRow(params.row)}
          checkboxSelection={false}
          disableSelectionOnClick
          processRowUpdate={(updatedRow) => {
            // Optional inline update logic
            return updatedRow;
          }}
        />
      )}

      <NewSupplierDialog
        show={openNewDialog}
        onClose={() => {
          setOpenNewDialog(false);
          fetchSuppliers();
        }}
      />

      <EditSupplierDialog
        show={openEditDialog}
        data={editRowData}
        onClose={() => {
          setOpenEditDialog(false);
          setSelectedRow(null);
          setEditRowData(null);
          fetchSuppliers();
        }}
        onSave={() => {
          setOpenEditDialog(false);
          setEditRowData(null);
          fetchSuppliers();
        }}
      />
    </Box>
  );
};

export default Suppliers;
